import styled, { css } from "styled-components";
import { pxToRem } from "styles/utils";

export const PageWrapper = styled.div<{ bottomOffset?: number }>`
  /* bottomOffset приходит от Telegram в физических пикселях. */
  min-height: calc(100vh + ${(props) => props.bottomOffset || 50}px);
  justify-content: space-between;
  background:
    radial-gradient(
      51% 51% at 50% 121%,
      ${({ theme }) => theme.colors.brandLight},
      ${({ theme }) => theme.colors.brandTransparent}
    ),
    ${({ theme }) => theme.colors.canvas};
  display: flex;
  flex-direction: column;
  align-items: center;
  overflow-y: auto;
  width: 100%;
  padding-bottom: ${(props) => props.bottomOffset || 50}px;
`;

export const LidHeader = styled.h2`
  color: ${({ theme }) => theme.colors.brand};
  font-size: ${({ theme }) => pxToRem(theme.fontSize.xxl)};
  font-weight: 700;
  margin: 0;
  margin-top: ${({ theme }) => pxToRem(theme.spacing.lg)};
`;

export const FormTitle = styled.h2`
  display: flex;
  color: ${({ theme }) => theme.colors.inkNearBlack};
  font-size: ${({ theme }) => pxToRem(theme.fontSize.xl)};
  font-weight: 600;
  margin: 0;
`;

export const Input = styled.input<{ hasError?: boolean }>`
  /* Физические 16px обязательны на iOS: иначе Safari зумит страницу при фокусе. */
  padding: 12px 16px;
  width: 100%;
  font-size: 16px;
  line-height: 1.25;
  border-radius: 10px;
  border: 1px solid ${({ theme }) => theme.colors.inkBorder};
  background: ${({ theme }) => theme.colors.canvas};
  scrollbar-width: none;
  outline: none;
  transition: border-color 0.15s ease, background-color 0.15s ease, box-shadow 0.15s ease;

  &::placeholder {
    color: ${({ theme }) => theme.colors.inkMuted};
    opacity: 1;
  }

  ${({ hasError, theme }) =>
    hasError &&
    css`
      border-color: ${theme.colors.danger};
      background: ${theme.colors.brandMedium};
    `}

  &:hover:not(:disabled) {
    border-color: ${({ theme }) => theme.colors.brand};
  }

  &:focus-visible {
    border-color: ${({ theme }) => theme.colors.brand};
    background: ${({ theme }) => theme.colors.brandMedium};
    box-shadow: inset 0 0 0 1px ${({ theme }) => theme.colors.brand};
  }

  &:disabled {
    cursor: not-allowed;
    opacity: 0.6;
  }
`;

export const FormFieldWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => pxToRem(theme.spacing.md)};
  width: 100%;
  max-width: ${pxToRem(560)};
  padding: 0 ${({ theme }) => pxToRem(theme.spacing.lg)};

  input {
    min-height: 44px;
    padding: 12px 16px;
    font-size: 16px;
    line-height: 1.25;
    color: ${({ theme }) => theme.colors.ink};
  }

  input::placeholder {
    color: ${({ theme }) => theme.colors.inkMuted};
    opacity: 1;
  }

  li {
    font-size: 16px;
    line-height: 1.25;
  }
`;

export const ButtonWrapper = styled.div`
  display: flex;
  width: 100%;
  max-width: ${pxToRem(560)};
  margin-top: ${({ theme }) => pxToRem(theme.spacing.lg)};
  margin-bottom: ${pxToRem(50)};
  padding: 0 ${({ theme }) => pxToRem(theme.spacing.lg)};

  button {
    min-height: 44px;
    height: 44px;
    font-size: 16px;
  }

  button:disabled {
    opacity: 0.5;
  }
`;
